// Rótulo compacto de unidade: em empreendimentos com mais de uma torre (ex.: Lumière, com
// torres A/B/T), a torre some junto do número — "702" vira "702B". Empreendimentos de torre
// única gravam `torre = 'Única'` nas `unidades` (não null) — por isso o filtro explícito abaixo,
// e não apenas "!torre".
export function formatUnidade(identificador, torre) {
  if (!identificador) return identificador || '';
  if (!torre || torre === 'Única') return String(identificador);
  return `${identificador}${torre}`;
}
